import React from 'react';
import { useAnalyticsOptOut } from './react.useAnalyticsOptOut';

// This file is a React component using JSX/TSX syntax

export function AnalyticsOptOutWidget() {
  const { visible, optedOut, toggleOptOut, toggleWidget } = useAnalyticsOptOut();

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 right-4 bg-yellow-100 rounded-xl p-3 shadow-lg z-50">
      <style>{`
        .bg-yellow-100 {
          background-color: #fff3c0 !important;
          color: #000 !important;
        }
      `}</style>
      <div className="text-sm font-medium text-gray-800">
        Analytics: {optedOut ? 'Disabled' : 'Active!'}
      </div>
      <div className="flex gap-2 mt-2">
        <button
          onClick={toggleOptOut}
          className="bg-gray-100 text-sm px-3 py-1 rounded border text-gray-800"
        >
          {optedOut ? 'Enable' : 'Disable'}
        </button>
        <button
          onClick={toggleWidget}
          className="text-xs text-gray-800 underline"
        >
          Hide
        </button>
      </div>
    </div>
  );
}

export default AnalyticsOptOutWidget; 